import axios from 'axios'

import env from '@lib/env'

const instance = axios.create({
  baseURL: `${env.API_URL}/demo`,
  headers: {
    'Content-Type': 'application/json',
    'X-Api-Key': 'Data wow',
  },
})

export default instance
